import React from 'react';
import { Form, Errors } from 'react-redux-form';
import Dropzone from 'react-dropzone';
import BaseDetailScreen from '../BaseDetailScreen';
import { baseUploadDriverLicensePath } from '../Forms/Schemas/baseRrf';
import Button from '../Button';
import blueCheck from '../../assets/images/blue_confirmation_check.png';
import loadingGif from '../../assets/images/loading.gif';

import './styles.css';

const UploadDriverLicense = (props) => {
  const {
    accountNumber,
    fileName,
    onDrop,
    onSubmit,
    fileErrors,
    instructions,
    isLoading,
    isComplete,
  } = props;
  const disableSubmit = fileName === 'No file selected' || (fileErrors && fileErrors.length > 0);
  // Upload Docs Form
  let comp = (
    <Form
      onSubmit={this.onSubmit}
      model={baseUploadDriverLicensePath}
      validators={{
        '': {
          hasFileErrors: () =>
            (fileErrors && fileErrors.length <= 0),
        },
      }}
    >
      {/* <UploadVerifyDocsForm
        docTypeOptions={docTypeOptions}
        uploadDocsPath={baseUploadDriverLicensePath}
      /> */}

      <React.Fragment>
        <Dropzone
          onDrop={onDrop}
          style={{
            width: '100%',
            height: '230px',
            border: 'solid 1px #c2d6e9',
          }}
          disablePreview
          multiple={false}
        />
        <div styleName="instruct">
          {instructions}
        </div>
        <div styleName="docName">
          {fileName}
        </div>
      </React.Fragment>

      <Errors
        styleName="errorText"
        component={compProps => <div>{compProps.children}</div>}
        model={baseUploadDriverLicensePath}
        messages={{
            hasFileErrors: (
              fileErrors && fileErrors.map(err => <div key={err}>{err}</div>)
            ),
          }}
      />
      <div styleName="submitBtn">
        <Button
          onClick={onSubmit}
          disabled={disableSubmit}
          type="submit"
        >
          Upload
        </Button>
      </div>
    </Form>
  );
  // Success view
  if (isComplete) {
    comp = (
      <div styleName="successGroup">
        <img
          src={blueCheck}
          alt="Checkmark"
          styleName="successCheck"
        />
        <div styleName="successText">Upload complete!</div>
      </div>
    );
  }
  // Loading view
  if (isLoading) {
    comp = (
      <div styleName="successGroup">
        <img
          src={loadingGif}
          alt="Loading"
          styleName="loading"
        />
        <div styleName="successText">Uploading...</div>
      </div>
    );
  }
  return (
    <BaseDetailScreen
      pageHeading="Upload Driver License"
      backTo={`/account/${accountNumber}`}
      backLabel="Manage Account"
    >
      <div styleName="uploadDocs">
        {comp}
      </div>
    </BaseDetailScreen>
  );
};

export default UploadDriverLicense;



// WEBPACK FOOTER //
// ./src/components/UploadDriverLicense/UploadDriverLicense.js